import {getCesium} from "@/modules/cesium/cesium";

export function getCesiumEntities() {
    return getCesium().getDataSourceDisplay().defaultDataSource.entities
}
